export const REDUX_SAVE_NOTIFICATIONS_COUNT = 'REDUX_SAVE_NOTIFICATIONS_COUNT'
